export default "__VITE_ASSET__f9f2ab6d__"